<!-- @format -->

<homefield-icon
	name="media-play-fill"
	class="common-media-play-button hmf-round-radius hmf-display-flex hmf-align-items-center hmf-justify-content-center"
	[class.common-media-play-button-small]="!isLarge()"
	[class.common-media-play-button-large]="isLarge()"
	[class.common-media-play-button-inverted]="invertColors()"
	[width]="isLarge() ? iconSize.large : iconSize.small"
	[height]="isLarge() ? iconSize.large : iconSize.small"
	[fill]="iconFill()"
/>